import { useEffect, useState } from 'react';
import { useSelectedTab } from '~/hooks/useSelectedTab';
import { MobileLayout_S } from '~/core/configuration/configuration-global-config.schema';
import { useSERPState } from '~/core/state/SERPStateContext';
import { useRenderingInfo } from '../contexts/useRenderingInfo';

interface UseShouldRenderSetProps {
    identifier?: string;
}

export const useShouldRenderSet = ({ identifier }: UseShouldRenderSetProps): boolean => {
    const { activeTab } = useSelectedTab();
    const { isMobileVersion } = useRenderingInfo();
    const { config } = useSERPState();
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (config.mobileLayout !== MobileLayout_S.Values.tabs || !isMobileVersion) {
            setShouldRender(true);
        } else {
            setShouldRender(activeTab?.result.querySetIdentifier === identifier);
        }
    }, [identifier, activeTab, isMobileVersion, config.mobileLayout]);

    return shouldRender;
};
